import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import logo from './image.png';
import './Header.css';

const Header = () => {
    const navigate = useNavigate();

    // On utilise userId maintenant pour vérifier si on est logué
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");

    // Si pas de userId, le header ne s'affiche pas (ex: sur la page Login)
    if (!userId) return null;

    const handleLogout = () => {
        // Pas besoin de fetch complexe ici vu qu'on gère tout par localStorage
        console.log("%c--- DÉCONNEXION @M SERVICES ---", "color: orange; font-weight: bold");

        localStorage.clear(); // Nettoie userId, userName, etc.
        navigate("/login");
    };

    return (
        <header className="main-header">
            <div className="header-left">
                <img src={logo} alt="@m Services" className="h-logo" />
            </div>

            <nav className="header-center">
                {/* Ici tu pourras rajouter tes futurs liens comme :
                <NavLink to="/admin" className="nav-link">Tableau de bord</NavLink> 
                */}
            </nav>

            <div className="header-right">

                <span className="user-welcome"> <strong>Kanban Aymeric</strong></span>
                <NavLink
                    to="/archives"
                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                >
                    Archives
                </NavLink>
                <button onClick={handleLogout} className="btn-logout">
                    Deconnection
                </button>
            </div>
        </header>
    );
};

export default Header;